
import React from "react";
import { Button } from "@/components/ui/button";

interface FormActionsProps {
  isDisabled: boolean;
  isSubmitting: boolean;
  editMode: boolean;
  onCancel?: () => void;
  onPrevious?: () => void;
}

const FormActions = ({ isDisabled, isSubmitting, editMode, onCancel, onPrevious }: FormActionsProps) => {
  return (
    <div className="flex flex-col gap-3 border-t border-brand-cloud pt-4 sm:flex-row sm:justify-end">
      {onPrevious ? (
        <Button type="button" variant="outline" onClick={onPrevious} className="w-full md:w-auto">
          Back
        </Button>
      ) : null}
      {editMode && onCancel ? (
        <Button type="button" variant="outline" onClick={onCancel} className="w-full md:w-auto">
          Cancel
        </Button>
      ) : null}
      <Button
        type="submit"
        disabled={isDisabled || isSubmitting}
        className="w-full md:w-auto"
      >
        {isSubmitting
          ? "Loading..."
          : editMode
          ? "Update Listing"
          : "Submit Listing"}
      </Button>
    </div>
  );
};

export default FormActions;
